<div class="ce-page">
  <h1 class="ce-title">{{ "crea.new_title" | translate }}</h1>

  <form [formGroup]="matrimonioForm" (ngSubmit)="submitForm()">

    <!-- ── ESSENZIALI: bastano per creare l'evento ── -->
    <div class="ce-group">
      <ng-container formGroupName="client">
        <label class="ce-row">
          <span class="ce-label"><span class="ce-icon"><app-icon name="user" [size]="15"></app-icon></span>{{ "crea.bride.name" | translate }} <span class="required">*</span></span>
          <input id="ce-name" type="text" formControlName="name" autocomplete="off" [placeholder]="'crea.bride.name_placeholder' | translate" />
        </label>
        <p class="field-error" *ngIf="matrimonioForm.get('client.name')?.invalid && matrimonioForm.get('client.name')?.touched">
          {{ "crea.required" | translate }}
        </p>
        <label class="ce-row">
          <span class="ce-label"><span class="ce-icon"><app-icon name="user" [size]="15"></app-icon></span>{{ "crea.bride.lastname" | translate }}</span>
          <input id="ce-lastname" type="text" formControlName="lastname" autocomplete="off" [placeholder]="'crea.bride.lastname_placeholder' | translate" />
        </label>
      </ng-container>

      <ng-container formGroupName="event">
        <label class="ce-row">
          <span class="ce-label"><span class="ce-icon"><app-icon name="calendar" [size]="15"></app-icon></span>{{ "crea.wedding.date" | translate }} <span class="required" *ngIf="!isQuote">*</span></span>
          <input id="ce-date" type="date" formControlName="date" />
        </label>
        <p class="field-error" *ngIf="matrimonioForm.get('event.date')?.invalid && matrimonioForm.get('event.date')?.touched">
          {{ "crea.required" | translate }}
        </p>
        <ng-container *ngIf="isQuote && !hasDate" formGroupName="date_hint">
          <div class="ce-row ce-row--stack ce-period">
            <span class="ce-label"><span class="ce-icon"><app-icon name="calendar" [size]="15"></app-icon></span>{{ "crea.period.label" | translate }}</span>
            <div class="ce-period-fields">
              <select formControlName="year" [attr.aria-label]="'crea.period.year' | translate">
                <option [ngValue]="null">{{ "crea.period.year" | translate }}</option>
                <option *ngFor="let y of periodYears" [ngValue]="y">{{ y }}</option>
              </select>
              <select formControlName="period">
                <option value="">{{ "crea.period.any" | translate }}</option>
                <option *ngFor="let p of periodOptions" [value]="p">{{ "crea.period." + p | translate }}</option>
              </select>
            </div>
            <p class="ce-period-hint">{{ "crea.period.hint" | translate }}</p>
          </div>
        </ng-container>
        <p class="ce-date-busy" *ngIf="busyDateName">
          <app-icon name="alert" [size]="14"></app-icon>
          {{ "quote.date_busy" | translate: { name: busyDateName } }}
        </p>
        <label class="ce-row">
          <span class="ce-label"><span class="ce-icon"><app-icon name="clock" [size]="15"></app-icon></span>{{ "crea.wedding.time" | translate }}</span>
          <app-time-picker formControlName="time"></app-time-picker>
        </label>
        <label class="ce-row ce-row--stack">
          <span class="ce-label"><span class="ce-icon"><app-icon name="pin" [size]="15"></app-icon></span>{{ "crea.wedding.location" | translate }}</span>
          <input id="ce-location" type="text" appPlacesAutocomplete (placeSelected)="onLocationPlace($event)" formControlName="location" [placeholder]="'crea.wedding.location_placeholder' | translate" />
        </label>
      </ng-container>

      <label class="ce-row" formGroupName="client">
        <span class="ce-label"><span class="ce-icon"><app-icon name="mail" [size]="15"></app-icon></span>{{ "crea.bride.email" | translate }}</span>
        <input type="email" inputmode="email" autocomplete="off" autocapitalize="off" formControlName="email" [placeholder]="'crea.bride.email_placeholder' | translate" />
      </label>

      <div class="ce-row ce-row--stack" formGroupName="client">
        <span class="ce-label"><span class="ce-icon"><app-icon name="phone" [size]="15"></app-icon></span>{{ "crea.bride.phone" | translate }}</span>
        <app-phone-input formControlName="phone" [placeholder]="'crea.bride.phone_placeholder' | translate"></app-phone-input>
      </div>
    </div>

    <label class="ce-toggle-row ce-quote-toggle">
      <span class="ce-contract-text">
        <strong>{{ "quote.create_toggle" | translate }}</strong>
        <small>{{ "quote.create_toggle_sub" | translate }}</small>
      </span>
      <span class="toggle-switch">
        <input type="checkbox" [checked]="isQuote" (change)="onQuoteChange($event)" />
        <span class="toggle-slider"></span>
      </span>
    </label>

    <p class="ce-hint">{{ "crea.optional_hint" | translate }}</p>

    <!-- ── DATI PER IL CONTRATTO ── -->
    <section class="ce-section" [class.open]="openSection === 'client'">
      <button type="button" class="ce-section-head" (click)="toggleSection('client')" [attr.aria-expanded]="openSection === 'client'">
        <span class="ce-icon"><app-icon name="file" [size]="15"></app-icon></span>
        <span class="ce-section-title">{{ "crea.sections.client" | translate }}</span>
        <span class="ce-section-summary">{{ "crea.summary.filled" | translate: { n: clientFilledCount, total: 3 } }}</span>
        <span class="ce-chevron">›</span>
      </button>
      <div class="ce-section-body" formGroupName="client">
        <label class="ce-field">
          <span>{{ "crea.bride.address" | translate }}</span>
          <input id="ce-address" type="text" formControlName="address" [placeholder]="'crea.bride.address_placeholder' | translate" />
        </label>
        <div class="ce-field-row">
          <label class="ce-field">
            <span>{{ "crea.bride.dob" | translate }}</span>
            <input id="ce-dob" type="date" formControlName="dateOfBirth" [max]="today" />
          </label>
          <label class="ce-field">
            <span>{{ "crea.bride.pob" | translate }}</span>
            <input id="ce-pob" type="text" formControlName="placeOfBirth" [placeholder]="'crea.bride.pob_placeholder' | translate" />
          </label>
        </div>
      </div>
    </section>

    <!-- ── PROVA / SOPRALLUOGO ── -->
    <section class="ce-section" [class.open]="openSection === 'trial'">
      <button type="button" class="ce-section-head" (click)="toggleSection('trial')" [attr.aria-expanded]="openSection === 'trial'">
        <span class="ce-icon"><app-icon name="sparkle" [size]="15"></app-icon></span>
        <span class="ce-section-title">{{ trialTitleKey | translate }}</span>
        <span class="ce-section-summary">{{ trialSummary }}</span>
        <span class="ce-chevron">›</span>
      </button>
      <div class="ce-section-body" formGroupName="event">
        <div class="ce-field-row">
          <label class="ce-field">
            <span>{{ "crea.wedding.date" | translate }}</span>
            <input type="date" formControlName="test_date" />
          </label>
          <label class="ce-field">
            <span>{{ "crea.wedding.time" | translate }}</span>
            <app-time-picker formControlName="test_time"></app-time-picker>
          </label>
        </div>
        <label class="ce-field">
          <span>{{ "crea.wedding.location" | translate }}</span>
          <input type="text" appPlacesAutocomplete (placeSelected)="onTestLocationPlace($event)" formControlName="test_location" [placeholder]="'crea.wedding.test_location_placeholder' | translate" />
        </label>
        <label class="ce-field">
          <span>{{ "crea.cost" | translate }}</span>
          <span class="ce-money">
            <span>€</span>
            <input type="number" formControlName="test_cost" min="0" step="0.01" inputmode="decimal" placeholder="0" />
          </span>
        </label>
      </div>
    </section>

    <!-- ── SERVIZI E TRASFERTA ── -->
    <section class="ce-section" [class.open]="openSection === 'services'">
      <button type="button" class="ce-section-head" (click)="toggleSection('services')" [attr.aria-expanded]="openSection === 'services'">
        <span class="ce-icon"><app-icon name="card" [size]="15"></app-icon></span>
        <span class="ce-section-title">{{ "crea.sections.services" | translate }}</span>
        <span class="ce-section-summary" *ngIf="totalAll > 0">€ {{ totalAll | number: "1.0-2" }}</span>
        <span class="ce-chevron">›</span>
      </button>
      <div class="ce-section-body" formGroupName="event">
        <app-load-error *ngIf="profileError" [message]="'profile.listino.load_error' | translate" (retry)="loadProfile()"></app-load-error>
        <p class="ce-empty" *ngIf="profileLoaded && weddingServices.length === 0">
          {{ "riepilogo.no_services_profile" | translate }} ·
          <button type="button" class="ce-link-btn" (click)="openListinoPanel()">{{ "crea.listino_panel.open" | translate }}</button>
        </p>

        <button type="button" class="ce-add-custom" (click)="addCustomService()">
          <app-icon name="plus" [size]="14"></app-icon>{{ "riepilogo.custom_service.add" | translate }}
        </button>

        <div formArrayName="services" id="ce-services" tabindex="-1" class="ce-services" *ngIf="weddingServices.length > 0">
          <div
            *ngFor="let svc of weddingServices.controls; let i = index"
            [formGroupName]="i"
            class="ce-service"
            [class.selected]="isSelected(i)"
          >
            <div class="ce-custom" *ngIf="svc.get('custom')?.value">
              <div class="ce-custom-head">
                <input type="text" class="ce-custom-name" formControlName="name" [placeholder]="'riepilogo.custom_service.name' | translate" />
                <button type="button" class="ce-custom-remove" (click)="removeCustomService(i)" [attr.aria-label]="'riepilogo.custom_service.remove' | translate">
                  <app-icon name="trash" [size]="14"></app-icon>
                </button>
              </div>
              <input type="text" class="ce-custom-desc" formControlName="description" [placeholder]="'riepilogo.custom_service.description' | translate" />
              <div class="ce-service-controls">
                <span class="ce-qty">
                  <button type="button" (click)="changeQuantity(i, -1)" [attr.aria-label]="'crea.qty_less' | translate">−</button>
                  <span>{{ quantity(i) }}</span>
                  <button type="button" (click)="changeQuantity(i, 1)" [attr.aria-label]="'crea.qty_more' | translate">+</button>
                </span>
                <span class="ce-money">
                  <span>€</span>
                  <input type="number" formControlName="price" min="0" step="0.01" inputmode="decimal" />
                </span>
                <span class="ce-subtotal">€ {{ subtotal(i) | number: "1.2-2" }}</span>
              </div>
            </div>
            <label class="ce-service-head" *ngIf="!svc.get('custom')?.value">
              <span class="ce-service-info">
                <span class="ce-service-name">{{ svc.get('name')?.value }}</span>
                <span class="ce-service-desc" *ngIf="svc.get('description')?.value">{{ svc.get('description')?.value }}</span>
              </span>
              <span class="toggle-switch">
                <input type="checkbox" formControlName="selected" />
                <span class="toggle-slider"></span>
              </span>
            </label>

            <div class="ce-service-controls" *ngIf="isSelected(i) && !svc.get('custom')?.value">
              <span class="ce-qty">
                <button type="button" (click)="changeQuantity(i, -1)" [attr.aria-label]="'crea.qty_less' | translate">−</button>
                <span>{{ quantity(i) }}</span>
                <button type="button" (click)="changeQuantity(i, 1)" [attr.aria-label]="'crea.qty_more' | translate">+</button>
              </span>
              <span class="ce-money">
                <span>€</span>
                <input type="number" formControlName="price" min="0" step="0.01" inputmode="decimal" />
              </span>
              <span class="ce-subtotal">€ {{ subtotal(i) | number: "1.2-2" }}</span>
            </div>
          </div>
        </div>

        <div class="ce-travel" [formGroup]="travelGroup">
          <span class="ce-travel-label"><app-icon name="car" [size]="16"></app-icon>{{ "riepilogo.travel.label" | translate }}</span>
          <span class="ce-money">
            <span>€</span>
            <input type="number" formControlName="cost" min="0" step="0.01" inputmode="decimal" placeholder="0" />
          </span>
          <button type="button" class="ce-travel-calc" (click)="calculateTravelFee()" [disabled]="calculatingTravel">
            {{ (calculatingTravel ? "riepilogo.travel.calculating" : "riepilogo.travel.calculate") | translate }}
            <app-icon *ngIf="!canPro" name="lock" [size]="13"></app-icon>
          </button>
        </div>
        <p class="ce-travel-note" *ngIf="travelBreakdown">{{ travelBreakdown }}</p>

        <div class="ce-discount" [formGroup]="discountGroup">
          <button type="button" class="ce-discount-head" (click)="discountOpen = !discountOpen" [attr.aria-expanded]="discountOpen">
            <span class="ce-travel-label"><app-icon name="euro" [size]="16"></app-icon>{{ "riepilogo.discount.label" | translate }}</span>
            <span class="ce-discount-value" *ngIf="totals.discount > 0">− € {{ totals.discount | number: "1.2-2" }}</span>
            <span class="ce-chevron" [class.open]="discountOpen">›</span>
          </button>
          <div class="ce-discount-body" *ngIf="discountOpen">
            <div class="ce-discount-row">
              <span class="ce-unit">
                <button type="button" [class.active]="discountType === 'fixed'" (click)="setDiscountType('fixed')" [attr.aria-label]="'deposit_toggle.fixed' | translate">€</button>
                <button type="button" [class.active]="discountType === 'percent'" (click)="setDiscountType('percent')" [attr.aria-label]="'deposit_toggle.percent' | translate">%</button>
              </span>
              <span class="ce-money">
                <span>{{ discountType === 'percent' ? '%' : '€' }}</span>
                <input type="number" formControlName="value" min="0" step="0.01" inputmode="decimal" placeholder="0" />
              </span>
            </div>
            <label class="ce-field">
              <span>{{ "riepilogo.discount.description" | translate }}</span>
              <input type="text" formControlName="label" maxlength="60" [placeholder]="'riepilogo.discount.description_placeholder' | translate" />
            </label>
            <label class="ce-toggle-row" *ngIf="discountType === 'percent' && travelFee > 0">
              <span>{{ "riepilogo.discount.include_travel" | translate }}</span>
              <span class="toggle-switch">
                <input type="checkbox" formControlName="include_travel" />
                <span class="toggle-slider"></span>
              </span>
            </label>
          </div>
        </div>

        <div class="ce-total" *ngIf="totalAll > 0 || totals.discount > 0">
          <span>{{ "crea.total" | translate }}</span>
          <strong>€ {{ totalAll | number: "1.2-2" }}</strong>
        </div>

        <label class="ce-toggle-row">
          <span>{{ "crea.show_prices" | translate }}</span>
          <span class="toggle-switch">
            <input type="checkbox" [checked]="show_prices" (change)="onShowPricesChange($event)" />
            <span class="toggle-slider"></span>
          </span>
        </label>
        <label class="ce-toggle-row">
          <span>{{ "crea.show_total" | translate }}</span>
          <span class="toggle-switch">
            <input type="checkbox" [checked]="show_total" (change)="onShowTotalChange($event)" />
            <span class="toggle-slider"></span>
          </span>
        </label>
      </div>
    </section>

    <!-- ── NOTE ── -->
    <section class="ce-section" [class.open]="openSection === 'notes'">
      <button type="button" class="ce-section-head" (click)="toggleSection('notes')" [attr.aria-expanded]="openSection === 'notes'">
        <span class="ce-icon"><app-icon name="note" [size]="15"></app-icon></span>
        <span class="ce-section-title">{{ "crea.notes" | translate }}</span>
        <span class="ce-section-summary">{{ notesSummary }}</span>
        <span class="ce-chevron">›</span>
      </button>
      <div class="ce-section-body" formGroupName="event">
        <label class="ce-field" formGroupName="note">
          <textarea formControlName="text" rows="4" [placeholder]="'crea.notes_placeholder' | translate"></textarea>
        </label>
        <label class="ce-toggle-row" formGroupName="note">
          <span class="ce-contract-text">
            <strong>{{ "quote.notes_toggle" | translate }}</strong>
            <small>{{ "quote.notes_toggle_sub" | translate }}</small>
          </span>
          <span class="toggle-switch">
            <input type="checkbox" formControlName="show_client" />
            <span class="toggle-slider"></span>
          </span>
        </label>
      </div>
    </section>

    <!-- ── CONTRATTO ── -->
    <div class="ce-contract" formGroupName="event" *ngIf="!isQuote">
      <div class="ce-toggle-row ce-contract-toggle">
        <span class="ce-contract-text">
          <strong>
            <label for="ce-generate">{{ "crea.generate_contract" | translate }}</label>
            <app-info-tooltip [text]="'crea.generate_contract_tooltip' | translate"></app-info-tooltip>
          </strong>
          <small>{{ "crea.generate_contract_sub" | translate }}</small>
        </span>
        <label class="toggle-switch">
          <input id="ce-generate" type="checkbox" [checked]="generateContract" (change)="onGenerateContractChange($event)" />
          <span class="toggle-slider"></span>
        </label>
      </div>

      <div class="ce-missing" *ngIf="generateContract && !contractDataReady">
        <p>{{ "crea.missing_title" | translate }}</p>
        <div class="ce-missing-list">
          <button type="button" class="ce-missing-item" *ngFor="let f of missingContractFields" (click)="goToField(f)">
            {{ "crea.missing." + f.key | translate }}
          </button>
        </div>
      </div>

      <div *ngIf="generateContract" formGroupName="contract" class="ce-field-row ce-contract-fields">
        <label class="ce-field">
          <span>{{ "crea.contract_date" | translate }} <app-info-tooltip [text]="'crea.contract_fields_tooltip' | translate"></app-info-tooltip></span>
          <input type="date" formControlName="dateOfContract" />
        </label>
        <label class="ce-field">
          <span>{{ "crea.contract_name" | translate }}</span>
          <input type="text" formControlName="name" [placeholder]="'crea.contract_name_placeholder' | translate" />
        </label>
      </div>
    </div>

    <!-- ── BARRA FISSA ── -->
    <div class="ce-footer">
      <button type="button" class="btn-outline ce-cancel" (click)="router.navigate(['/eventi'])">
        {{ "crea.cancel" | translate }}
      </button>
      <button type="submit" class="btn-gold ce-submit" [disabled]="saving">
        {{ (saving ? "crea.saving" : isQuote ? "quote.create_btn" : "crea.create") | translate }}
      </button>
    </div>

  </form>
</div>

<!-- Nuova voce di listino: pannello dal basso, il form dell'evento resta com'è -->
<ng-container *ngIf="listinoPanelOpen">
  <div class="ce-sheet-backdrop" (click)="closeListinoPanel()"></div>
  <div class="ce-sheet" role="dialog" [attr.aria-label]="'crea.listino_panel.title' | translate">
    <div class="ce-sheet-handle"></div>
    <h3 class="ce-sheet-title">{{ "crea.listino_panel.title" | translate }}</h3>
    <p class="ce-sheet-desc">{{ "crea.listino_panel.desc" | translate }}</p>
    <label class="ce-sheet-field">
      <span>{{ "riepilogo.custom_service.name" | translate }}</span>
      <input type="text" [(ngModel)]="newListino.name" [ngModelOptions]="{ standalone: true }" />
    </label>
    <label class="ce-sheet-field">
      <span>{{ "crea.cost" | translate }} (€)</span>
      <input type="number" min="0" step="0.01" inputmode="decimal" [(ngModel)]="newListino.price" [ngModelOptions]="{ standalone: true }" />
    </label>
    <label class="ce-sheet-field">
      <span>{{ "riepilogo.custom_service.description" | translate }}</span>
      <input type="text" [(ngModel)]="newListino.description" [ngModelOptions]="{ standalone: true }" />
    </label>
    <div class="ce-sheet-actions">
      <button type="button" class="ce-sheet-cancel" (click)="closeListinoPanel()">{{ "common.cancel" | translate }}</button>
      <button type="button" class="ce-sheet-save" (click)="saveListinoItem()" [disabled]="savingListino">{{ "crea.listino_panel.save" | translate }}</button>
    </div>
  </div>
</ng-container>
